/*  Shared  */
import { Response } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import { useEffect, useMemo, useState } from 'react';

// Hook to fetch the /applicationAccounts response
const defaultObject = {};
// Always define the params object outside the component using it, otherwise
// you will keep rendering and re-rendering the component.
export const useFetchApplicationAccounts = ({
    clientId = null,
    params = defaultObject
}) => {
    const [accounts, setAccounts] = useState([]);
    const [loading, setLoading] = useState(true);
    // calling refetchData will force a rerender on the hook
    const [shouldRefetchData, setShouldRefetch] = useState({});

    const refetchData = () => setShouldRefetch({});

    const parameters = useMemo(
        () =>
            clientId
                ? {
                      ...params,
                      platformTenantId: clientId
                  }
                : params,
        [clientId, params]
    );

    useEffect(() => {
        const { CancelToken } = axios;
        const source = CancelToken.source();

        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await axios.get('/applicationAccounts', {
                    cancelToken: source.token,
                    params: parameters
                });
                if (!Response.hasData(response, { noId: true })) {
                    debug.w('No accounts found.', response);
                } else {
                    const data = Response.getData(response, { noId: true });

                    const sortedData = data.sort((aUsername, bUsername) =>
                        `${aUsername}`.localeCompare(bUsername)
                    );
                    setAccounts(sortedData);
                }
            } catch (error) {
                debug.e('Error getting accounts.', error);
            }
            setLoading(false);
        };
        fetchData();

        return () => {
            // Cancel the request when the component unmounts
            source.cancel();
        };
    }, [clientId, parameters, shouldRefetchData]);

    return {
        accounts,
        loading,
        refetchData
    };
};
